import { render, staticRenderFns } from "./InformationSent.vue?vue&type=template&id=768b75e9"
import script from "./InformationSent.vue?vue&type=script&lang=js"
export * from "./InformationSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports